import { xIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Close = createIcon({
  displayName: 'Close',
  paths: [
    'M721.045 256c-10.923 0-21.845 4.181-30.165 12.501l-181.035 181.035-180.992-181.035c-8.363-8.32-19.285-12.501-30.165-12.501-10.923 0-21.845 4.181-30.165 12.501-16.683 16.64-16.683 43.648 0 60.331l180.992 181.035-180.992 180.992c-16.683 16.683-16.683 43.691 0 60.331 8.32 8.363 19.243 12.501 30.165 12.501 10.88 0 21.803-4.139 30.165-12.501l180.992-180.992 181.035 180.992c8.32 8.363 19.243 12.501 30.165 12.501s21.845-4.139 30.165-12.501c16.683-16.64 16.683-43.648 0-60.331l-181.035-180.992 181.035-181.035c16.683-16.683 16.683-43.691 0-60.331-8.32-8.32-19.243-12.501-30.165-12.501z'
  ],
  canvasPaths: canvasIconPaths(xIcon)
})
